module.exports = __webpack_public_path__ + "img/case-logo-03.edf0c3ff.png";